import { useDropzone } from 'react-dropzone';
import styles from './styles.module.scss';
import { FileCircleIcon, RemoveIcon } from '../../assets/icons/common';
import { Dispatch, MouseEvent, SetStateAction } from 'react';
import Button from '../../components/Button';

interface Props {
    label?: string;
    uploadFunc?: any;
    file: File | null;
    uploading: boolean;
    isRequired?: boolean;
    description?: string;
    fileTypes: { [key: string]: string[] };
    setFile: Dispatch<SetStateAction<File | null>>;
};

export default function DropBox(props: Props) {
    const {
        file,
        label,
        setFile,
        uploading,
        fileTypes,
        uploadFunc,
        isRequired,
        description,
    } = props;

    const { getRootProps, getInputProps, open } = useDropzone({
        noClick: true,
        accept: fileTypes,
        onDrop: acceptedFiles => {
            onSelectFile(acceptedFiles)
        },
    });

    function onSelectFile(files: File[]) {
        if (files && files.length > 0) {
            setFile(files[0]);
        }
    };

    const removeFile = (e: MouseEvent<SVGSVGElement>) => {
        e.stopPropagation();
        setFile(null);
    };

    return (
        <div className={styles.container}>
            {label && <span className={styles.label}>{label} {isRequired && <b>*</b>}</span>}
            <section className={styles.uploadBox} onClick={open}>
                <div
                    {...getRootProps({
                        className: 'dropzone',
                        style: {
                            width: '100%',
                            height: '100%',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            justifyItems: 'center',
                            position: 'relative',
                        }
                    })}
                >
                    {file && <RemoveIcon
                        fill='#FF0000'
                        onClick={removeFile}
                        style={{
                            position: 'absolute',
                            cursor: 'pointer',
                            right: '0',
                            top: '0',
                        }}
                    />}
                    <input {...getInputProps()} />
                    <FileCircleIcon />
                    {!file && <>
                        <span className={styles.title}>
                            Drop your files here or <b>browse</b>
                        </span>
                        <span className={styles.uploadBox_description}>
                            {description}
                        </span>
                    </>}
                    {file && <>
                        <span>{file.name}</span>
                        {uploadFunc && <Button
                            text='Upload'
                            loading={uploading}
                            onClick={uploadFunc}
                            className={styles.upload_btn}
                        />}
                    </>}
                </div>
            </section>
        </div>
    )
}
